import React, { useState } from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Modal from '../../modals/Modal';
import Button from '../../shared/Button';

const CaseRequestConsultationDateModal = (props) => {
  const { open, onClose, selectedCase, onSubmit, loading } = props;

  const [date, setDate] = useState(moment().add(7, 'days'));

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Request New Consultation Date"
      subtitle={selectedCase?.formattedId || selectedCase?.id}
      onSubmit={() => onSubmit(date)}
      size="md"
      autoSize
      disabled={loading}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <div className="d-flex direction-column space-between">
          <div className="p-lg width-100">
            <div className="secondary">Consultation Date</div>
            <DatePicker
              desktopModeMediaQuery="(min-width: 0px)"
              format="DD/MM/YYYY"
              value={selectedCase?.consultationDate ? moment(selectedCase.consultationDate) : null}
              disabled
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                },
              }}
            />
          </div>

          {/* Desktop text */}
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <div className="p-lg font-bold" style={{ maxWidth: 400 }}>
              Please request a new consultation date below that will be reviewed & approved by any admin
            </div>
          </Box>

          {/* Mobile text */}
          <Box sx={{ display: { md: 'none' } }}>
            <div className="p-lg">
              Please request a new consultation date below that will be reviewed & approved by any admin
            </div>
          </Box>

          <div className="p-lg width-100">
            <div className="secondary">Requested Consultation Date</div>
            <DatePicker
              desktopModeMediaQuery="(min-width: 0px)"
              format="DD/MM/YYYY"
              value={date}
              onChange={(newDate) => setDate(newDate)}
              minDate={moment()}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                },
              }}
            />
          </div>
        </div>
      </LocalizationProvider>

      <div className="d-flex w-100 space-between p-lg m-t-lg">
        <div className="secondary pointer" onClick={onClose}>
          Cancel
        </div>
        <Button
          text="Request Date"
          color="primary"
          onClick={() => onSubmit(date)}
          disabled={loading}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default CaseRequestConsultationDateModal;
